import type { VatStatementBlock } from '../../../../utils/statementBlocks';
import { FigureCell } from './FigureCell';
import { LABEL_SPAN_TO_NET, STATEMENT_GRID } from './statementGrid';
import { UnsplitBadge } from './UnsplitBadge';

interface Props {
    block: VatStatementBlock;
    currency: string;
}

export function BlockTotalRow({ block, currency }: Props) {
    return (
        <div className={`${STATEMENT_GRID} border-t border-mp-border bg-mp-surface py-1 text-sm font-semibold`}>
            <dt className={`flex flex-wrap items-center gap-2 ${block.split ? '' : LABEL_SPAN_TO_NET}`}>
                <span>Total</span>
                {block.unsplit.postings > 0 && <UnsplitBadge postings={block.unsplit.postings} />}
            </dt>
            {block.split && (
                <>
                    <dd aria-hidden="true" />
                    <FigureCell column="Gross" value={block.total.gross} currency={currency} />
                    <FigureCell column="VAT" value={block.total.vat} currency={currency} />
                </>
            )}
            <FigureCell column="Net" value={block.total.net} currency={currency} />
        </div>
    );
}
